import React from 'react'

type Props = {}

const LoginPage = (props: Props) => {
  return (
    <div>LoginPage</div>
  )
}

export default LoginPage